export default __webpack_public_path__ + "static/media/configurations_icon.11b8e015.svg";